import {useState} from "react";
import SearchBar from "./searchBar";
import FilterCard from "../../components/offer/filterCard";
import {offerStatus, userRoleList} from "../../../utils/constants";

const FilterBanner = ({SetFilter, data, sectors}) => {
  const [filterBut, setFilterBut] = useState(false);
  const [filterTouched, setFilterTouched] = useState(false);

  return (
    <div className="flex flex-col gap-4 w-full">
      <div className="w-full flex items-center gap-2">
        <SearchBar SetFilter={SetFilter} />

        <div
          className="flex justify-center items-center bg-white min-w-12 aspect-square rounded-full text-[#19295C] cursor-pointer"
          onClick={() => {
            setFilterBut((prev) => !prev);
          }}
        >
          <i className="fi fi-rr-filter flex justify-center items-center relative">
            {!!filterTouched && (
              <div className="w-[10px] h-[10px] absolute -top-[7px] -right-[7px] bg-[#FF6600] rounded-full"></div>
            )}
          </i>
        </div>
      </div>

      <div
        className={`transform transition-all duration-300 ${
          filterBut
            ? "opacity-100 h-fit translate-y-0"
            : "opacity-0  h-0 -translate-y-5 hidden"
        }`}
      >
        <FilterCard
          user={data}
          setFilter={SetFilter}
          setFilterTouched={setFilterTouched}
          sectors={sectors}
          initialFilter={{
            size: 8,
            order: [["id", "DESC"]],
            filter:
              data?.selectedRole === userRoleList.TECHNICIAN
                ? {
                    statuses: [offerStatus.PUBLIC],
                    sectorIds: !!sectors?.length
                      ? sectors?.map((el) => parseInt(el.id))
                      : [],
                  }
                : {clientId: data?.Client?.id},
            search: "",
          }}
        />
      </div>
    </div>
  );
};

export default FilterBanner;
